import { gql } from '@apollo/client';

export const DONATION_COUNT = gql`
  query getDonationCount($email: String!) {
    user(email: $email, returnDonationCount: true) {
      email
      donationCount
    }
  }
`;

export default {};
